import React from 'react';
import b_ from 'b_';
import I18N from 'assets/i18n/brandlift-project';
import {createLink} from 'client/common/utils/window';

import './header2.css';

const i18n = I18N.common.header2;
const b = b_.with('header2');

export const meaningfulWrapperClassName = b('menu', {type: 'main'});
export const meaningfulElemName = 'menu-link';
export const headerMeaningfulSelector = `.${meaningfulWrapperClassName} .${b(meaningfulElemName)}`;

export const CreativesHelpUrls = {
    creative: I18N.surveyStats.creativeStats.scoreboard.help.link.creative,
    bordomatik: I18N.surveyStats.creativeStats.scoreboard.help.link.bordomatik
};

export const CREATIVE_LINKS = [
    {
        value: 'creatives',
        content: (
            <a
                className={b(meaningfulElemName, {type: 'creatives'})}
                href={createLink(i18n.links.creatives)}
            >
                {i18n.list.creatives}
            </a>
        )
    },
    {
        value: 'bordomatiks',
        content: (
            <a
                className={b(meaningfulElemName, {type: 'bordomatiks'})}
                href={createLink(i18n.links.bordomatiks)}
            >
                {i18n.list.bordomatiks}
            </a>
        )
    }
];
